const EN_US = require('./en-us')

const LANGUAGES = {
  EN_US: EN_US
}

module.exports = LANGUAGES
